module.exports = __webpack_public_path__ + "img/oufu_38x55x8b.prt.fa0cfdd4.jpg";